import {
  CCASubdomain,
  CCA_SUBDOMAINS,
  SubdomainBadgeColors,
} from '../../../../../../questions/CCABank/ccaConstants';

export const toTitleCase = (s: string): string =>
  s
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

export const getSubdomainColor = (subdomain: string): string => {
  const key = subdomain.includes('_') ? toTitleCase(subdomain) : subdomain;
  return SubdomainBadgeColors[key as CCASubdomain] ?? 'bg-slate-100 text-slate-600';
};

export interface QuickBuildConfig {
  subdomains: CCASubdomain[];
  level: number;
  timeLimitSeconds: number;
  totalQuestions: number;
  shortAnswerCount: number;
  wordyCount: number;
}

export const defaultQuickBuildConfig: QuickBuildConfig = {
  subdomains: [...CCA_SUBDOMAINS],
  level: 6,
  timeLimitSeconds: 60,
  totalQuestions: 6,
  shortAnswerCount: 3,
  wordyCount: 3,
};
